import { render, staticRenderFns } from "./JiShiClockDetail.vue?vue&type=template&id=06ccd722&scoped=true&"
import script from "./JiShiClockDetail.vue?vue&type=script&lang=js&"
export * from "./JiShiClockDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiShiClockDetail.vue?vue&type=style&index=0&id=06ccd722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ccd722",
  null
  
)

export default component.exports